const LOAD_DETAIL_COURSE           = 'LOAD_DETAIL_COURSE'
const LOAD_DETAIL_COURSE_SUCCESS   = 'LOAD_DETAIL_COURSE_SUCCESS'
const LOAD_DETAIL_COURSE_FAILED    = 'LOAD_DETAIL_COURSE_FAILED'
const UNMOUNT_DETAIL_COURSE        = 'UNMOUNT_DETAIL_COURSE'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const courseDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_COURSE:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_COURSE_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_COURSE_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_COURSE:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default courseDetailReducer;